export default "__VITE_ASSET__CTbv9HFB__"